import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import LoanOffer from "../components/LoanOffer";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faHandHoldingDollar, faXmark, faCircleNotch, faPlus } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { Link } from "react-router-dom";
import { getCurrencySymbol, formatCurrency, getRate } from '../utils/currencyUtils';
import Modal from 'react-modal';
import { toast } from 'react-hot-toast';

//FILE UPLOAD
import { FilePond, registerPlugin } from 'react-filepond'
import 'filepond/dist/filepond.min.css'
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview)

function GetLoan() {
  const { user } = useUser();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const [title, setTitle] = useState();
  const [min, setMin] = useState();
  const [max, setMax] = useState();
  const [lrate, setLrate] = useState();
  const [duration, setDuration] = useState();
  const [files, setFiles] = useState([]);
  const [description, setDescription] = useState('');
  const [file_name, setFile_name] = useState();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
    const r = await getRate(currencyCode);
    if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  const [loanOffer, setLoanOffer] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchoffer: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setLoanOffer(data.offers);
      }
    })
    .catch(err => {
    })
  }, [user]);
  useEffect(() => {
    if(file_name && title && min && max && duration && lrate && description){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [file_name, title, min, max, duration, lrate, description]);
  const AddLoanOffer = () =>{
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/loan.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ btn_addoffer: true, file_name : file_name, title : title, min : min, max : max, rate : lrate, duration : duration, description : description})
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        toast.success(data.result);
        setTimeout(() => {
            window.location.href = "getloan";
          }, 2000);
      }else{
        toast.error(data.message);
      }
      setLoading(false);
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
    })
  }

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Get a Loan" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Get a Loan" icon={<FontAwesomeIcon icon={faHandHoldingDollar} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="mb-4 mt-3">
              <div className="d-flex align-items-center justify-content-between flex-wrap">
                <div>
                  <h5 className="mb-0" style={{fontWeight:'900',lineHeight:'120%'}}>Loan Application</h5>
                  <p className="mb-0" style={{fontSize:'14px'}}><Link to="/loan" className="noLink text-prime fw-semibold">Loan</Link> <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} /> Select Type</p>
                </div>
                {user?.user_type === "adminface" && (
                <div className="myBtn fe-semibold px-3 rounded-0" onClick={() => setIsOpen(true)} style={{fontSize:'14px'}}><FontAwesomeIcon icon={faPlus} style={{fontSize: '14px'}} className="me-1" /> Add Type</div>
                )}
              </div>
            </div>
            <p className="mb-0 text-center" style={{fontWeight:'900',fontSize:'18px'}}>Choose Your Loan Type</p>
            <p className="mb-0 text-center" style={{fontSize:'14px'}}>Select the type of loan that best fits your needs</p>
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2">
                        <div className="row">
                            {loanOffer.map((loan, index) => (
                            <div className="col-md-6 g-4">
                                <LoanOffer key={index} loan={loan}/>
                            </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
          </main>
        </div>
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => setIsOpen(false)}
            shouldCloseOnOverlayClick={true} 
            closeTimeoutMS={100}
            className="shortmode"
        >
            <div className="d-flex align-items-center justify-content-between">
                <p className="mb-0 fw-bold text-white" style={{fontSize: '16px'}}>Add Loan Type</p>
                <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
            </div>
            <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>Photo</label>
            <FilePond
              files={files}
              onupdatefiles={setFiles}
              allowMultiple={false}
              maxFiles={3}
              name="file"
              labelIdle="Click here to upload payment proof"
              server={{
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                  const formData = new FormData();
                  formData.append("file", file);
                  const request = new XMLHttpRequest();
                  request.open("POST", `${process.env.REACT_APP_API_URL}controller/upload.php`);
                  request.upload.onprogress = (e) => {
                    progress(e.lengthComputable, e.loaded, e.total);
                  };
                  request.onload = () => {
                    const res = JSON.parse(request.responseText);
                    if (res.success) {
                      setFile_name(res.filename);
                      load(res.filename);
                    } else {
                      error(res.error || "Upload failed");
                    }
                  };
                  request.onerror = () => {
                    error("Upload error");
                  };
                  request.send(formData);
                  return {
                    abort: () => {
                      request.abort();
                      abort();
                    }
                  };
                },
                revert: (serverId, load, error) => {
                  fetch(`${process.env.REACT_APP_API_URL}controller/delete.php`, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ filename: file_name })
                  })
                    .then((res) => res.json())
                    .then((data) => {
                      if (data.success) {
                        setFile_name("");
                        setFiles([]);
                        load();
                      } else {
                        error(data.error || "Failed to delete file");
                      }
                    })
                    .catch(() => {
                      error("Delete request failed");
                    });
                }
              }}
            />
            <label className="fw-semibold mb-1" style={{fontSize: '14px'}}>Title:</label>
            <div className="form-control py-2">
                <input 
                  type="text"
                  placeholder=""
                  className="inputNone"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
            </div>
            <div className="row">
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Min Amount:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="1000"
                      className="inputNone"
                      value={min}
                      onChange={(e) => setMin(e.target.value)}
                    />
                    <div
                      className="fw-bold text-white d-flex align-items-center"
                      style={{
                        backgroundColor: 'rgb(30, 33, 36)',
                        borderRadius: '4px',
                        padding: '6px',
                        fontSize: '14px',
                        cursor: 'pointer' 
                      }}
                    >
                    USD
                    </div>
                </div>
              </div>
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Maximum Amount:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="1000"
                      className="inputNone"
                      value={max}
                      onChange={(e) => setMax(e.target.value)}
                    />
                    <div
                      className="fw-bold text-white d-flex align-items-center"
                      style={{
                        backgroundColor: 'rgb(30, 33, 36)',
                        borderRadius: '4px',
                        padding: '6px',
                        fontSize: '14px',
                        cursor: 'pointer' 
                      }}
                    >
                    USD
                    </div>
                </div>
              </div>
            </div>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Rate:</label>
            <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                <input 
                  type="number"
                  placeholder="40"
                  className="inputNone"
                  value={lrate}
                  onChange={(e) => setLrate(e.target.value)}
                />
                <div
                  className="fw-bold text-white d-flex align-items-center"
                  style={{
                    backgroundColor: 'rgb(30, 33, 36)',
                    borderRadius: '4px',
                    padding: '6px',
                    fontSize: '14px',
                    cursor: 'pointer' 
                  }}
                >
                  %
                </div>
            </div>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Duration:</label>
            <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                <input 
                  type="number"
                  placeholder="6"
                  className="inputNone"
                  value={duration}
                  onChange={(e) => setDuration(e.target.value)}
                />
                <div
                  className="fw-bold text-white d-flex align-items-center"
                  style={{
                    backgroundColor: 'rgb(30, 33, 36)',
                    borderRadius: '4px',
                    padding: '6px',
                    fontSize: '14px',
                    cursor: 'pointer' 
                  }}
                >
                  Months
                </div>
            </div>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Loan Description:</label>
            <div className={`form-control justify-content-between py-1 pe-1 `}>
                <textarea 
                  rows={3}
                  className="inputNone w-100"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
            </div>  
            <div className={`myBtn w-100 text-center mt-3 ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable ? AddLoanOffer : null}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Add'}</div>
        </Modal>
      </div>
    </div>
  )
}

export default GetLoan